import {
  citationRowsToStripSuggestions,
  collectBotWebUrlButtonUrls,
  normalizeStripUrlKey,
  suggestionStripItemUrlKeys,
} from './chatUtils.js'
import { fetchWidgetEmbeddingByUrl } from './embeddingsApi.js'

function urlsNeedingLookup(buttons, existingSuggestions) {
  const seen = suggestionStripItemUrlKeys(existingSuggestions)
  const out = []
  for (const url of collectBotWebUrlButtonUrls(buttons)) {
    const key = normalizeStripUrlKey(url)
    if (key && !seen.has(key)) out.push(url)
  }
  return out
}

function resolveOneCached({ cache, apiBaseUrl, agentId, masterKey, url, signal }) {
  const cacheKey = `${agentId}::${url}`
  if (cache.has(cacheKey)) return cache.get(cacheKey)
  const p = fetchWidgetEmbeddingByUrl({
    apiBaseUrl,
    agentId,
    masterKey,
    url,
    signal,
  })
    .catch(() => null)
    .then((row) => {
      cache.set(cacheKey, row)
      return row
    })
  cache.set(cacheKey, p)
  return p
}

/**
 * Resolve `web_url` bot buttons to page/product strip cards when the URL
 * exists in embeddings. Postbacks and unmatched URLs stay in the bubble only.
 */
export async function resolveButtonEmbeddingStripSuggestions({
  buttons,
  conf = null,
  existingSuggestions = [],
  apiBaseUrl,
  agentId,
  masterKey,
  lookupCache = new Map(),
  signal,
}) {
  if (!agentId || !apiBaseUrl) return []
  const urls = urlsNeedingLookup(buttons, existingSuggestions)
  if (urls.length === 0) return []

  const rows = (
    await Promise.all(
      urls.map((url) =>
        resolveOneCached({
          cache: lookupCache,
          apiBaseUrl,
          agentId,
          masterKey,
          url,
          signal,
        }),
      ),
    )
  ).filter(Boolean)

  return citationRowsToStripSuggestions(rows, conf, existingSuggestions)
}
